module.exports = __webpack_public_path__ + "img/icon03.0fe8ea46.png";